<template>
  <v-container fluid>
    <!-- Botón volver -->
    <v-btn text class="mb-3" :to="{ name: 'asignacion-beneficiarios-listado' }">
      <v-icon left>mdi-arrow-left</v-icon>
      Volver al listado
    </v-btn>

    <v-row>
      <!-- Columna izquierda: Información, Estado, Documentos/Observaciones/Bitácora -->
      <v-col cols="12" md="6">
        <!-- Información del beneficiario -->
        <v-card :loading="cargando">
          <v-card-title class="d-flex align-center">
            <v-icon left class="mr-2">mdi-account</v-icon>
            {{ postulacion.nombre_completo || getNombreCompleto(postulacion) }}
            <v-spacer />
            <v-chip :color="getEstadoColor(postulacion.estado)" dark class="mr-2">
              {{ getEstadoTexto(postulacion.estado) }}
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>RUT</v-list-item-subtitle>
                  <v-list-item-title>{{ postulacion.rut }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Sector</v-list-item-subtitle>
                  <v-list-item-title>
                    <v-chip x-small :color="getSectorColor(postulacion.sector)">
                      {{ getSectorTexto(postulacion.sector) }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.correo_electronico">
                <v-list-item-content>
                  <v-list-item-subtitle>Correo</v-list-item-subtitle>
                  <v-list-item-title>{{ postulacion.correo_electronico }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.certificado">
                <v-list-item-content>
                  <v-list-item-subtitle>Municipalidad</v-list-item-subtitle>
                  <v-list-item-title>{{ postulacion.certificado.municipalidad_id }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.fecha_beneficiario">
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha asignación como beneficiario</v-list-item-subtitle>
                  <v-list-item-title>{{ formatearFecha(postulacion.fecha_beneficiario) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.fecha_pago">
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha de pago</v-list-item-subtitle>
                  <v-list-item-title>{{ formatearFecha(postulacion.fecha_pago) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>

        <!-- Evaluar Cumplimiento de Requisitos (solo para estado 'enviada' u 'observada', SUBDERE) -->
        <!-- <v-card v-if="['enviada', 'observada'].includes(postulacion.estado) && esSubdere" class="mt-4">
          <v-card-title>
            <v-icon left class="mr-2">mdi-clipboard-check</v-icon>
            Evaluar Cumplimiento de Requisitos
          </v-card-title>
          <v-card-text>
            <v-alert type="info" dense text class="mb-4">
              Evalúe si esta postulación cumple los requisitos antes de validarla.
            </v-alert>

            <v-chip v-if="postulacion.cumple_requisitos === true" color="success" dark class="mb-4">
              <v-icon small left>mdi-check</v-icon> Cumple requisitos
            </v-chip>
            <v-chip v-else-if="postulacion.cumple_requisitos === false" color="error" dark class="mb-4">
              <v-icon small left>mdi-close</v-icon> No cumple requisitos
            </v-chip>

            <v-radio-group v-model="cumpleRequisitos" row>
              <v-radio :value="true" color="success">
                <template #label>
                  <span class="success--text">
                    <v-icon small color="success" left>mdi-check-circle</v-icon>
                    Sí, cumple requisitos
                  </span>
                </template>
              </v-radio>
              <v-radio :value="false" color="error">
                <template #label>
                  <span class="error--text">
                    <v-icon small color="error" left>mdi-close-circle</v-icon>
                    No cumple requisitos
                  </span>
                </template>
              </v-radio>
            </v-radio-group>

            <v-alert v-if="cumpleRequisitos === false" type="warning" dense text class="mt-2">
              Esta postulación se marcará como "No cumple requisitos" y no podrá ser validada.
            </v-alert>

            <v-btn
              color="primary"
              :loading="guardandoCumple"
              :disabled="cumpleRequisitos === null"
              @click="guardarCumpleRequisitos"
            >
              <v-icon left>mdi-content-save</v-icon>
              Guardar Evaluación
            </v-btn>
          </v-card-text>
        </v-card> -->

        <!-- Cambiar Estado -->
        <v-card v-if="transicionesDisponibles.length > 0" class="mt-4">
          <v-card-title>
            <v-icon left class="mr-2">mdi-swap-horizontal</v-icon>
            Cambiar Estado
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="transicionSeleccionada"
              :items="transicionesDisponiblesSelect"
              label="Nuevo estado"
              outlined
              dense
              @change="cargarDocumentosRequeridos"
            />

            <!-- Documentos requeridos para la transición -->
            <template v-if="transicionSeleccionada && documentosRequeridos.length > 0">
              <v-divider class="my-3" />
              <v-subheader class="px-0">
                Documentos requeridos para esta transición
              </v-subheader>

              <v-card
                v-for="(doc, idx) in documentosRequeridos"
                :key="idx"
                outlined
                class="pa-3 mb-2"
              >
                <div class="d-flex align-center mb-2">
                  <v-icon
                    :color="doc.subido ? 'green' : (doc.obligatorio ? 'red' : 'grey')"
                    class="mr-2"
                  >
                    {{ doc.subido ? 'mdi-check-circle' : (doc.obligatorio ? 'mdi-alert-circle' : 'mdi-circle-outline') }}
                  </v-icon>
                  <span>
                    {{ doc.label }}
                    <v-chip v-if="doc.obligatorio" x-small color="red" dark class="ml-1">Obligatorio</v-chip>
                    <v-chip v-else x-small color="grey" dark class="ml-1">Opcional</v-chip>
                  </span>
                </div>
                <v-file-input
                  v-if="!doc.subido"
                  v-model="archivosTransicion[doc.tipo]"
                  accept=".pdf"
                  :label="'Seleccionar ' + doc.label"
                  outlined
                  dense
                  hide-details
                  prepend-icon="mdi-file-pdf-box"
                />
                <v-chip v-else small color="green" dark>
                  <v-icon small left>mdi-check</v-icon>
                  Documento ya subido
                </v-chip>
              </v-card>
            </template>

            <!-- Botón confirmar transición -->
            <v-btn
              v-if="transicionSeleccionada"
              color="primary"
              class="mt-3"
              :loading="procesandoTransicion"
              :disabled="!puedeConfirmarTransicion"
              @click="confirmarTransicion"
            >
              <v-icon left>mdi-check</v-icon>
              Confirmar cambio a {{ getEstadoTexto(transicionSeleccionada) }}
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- Tabs: Documentos, Observaciones, Bitácora -->
        <v-card class="mt-4">
          <v-tabs v-model="tabActiva" background-color="primary" dark>
            <v-tab>
              <v-icon left>mdi-file-document-multiple</v-icon>
              Documentos
            </v-tab>
            <v-tab>
              <v-icon left>mdi-comment-text-multiple</v-icon>
              Observaciones
              <v-badge
                v-if="observacionesSinResponder > 0"
                :content="observacionesSinResponder"
                color="red"
                class="ml-2"
              />
            </v-tab>
            <v-tab>
              <v-icon left>mdi-history</v-icon>
              Bitácora
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabActiva">
            <!-- Tab Documentos -->
            <v-tab-item>
              <v-card-text>
                <!-- Documentos de Etapa 1 (Postulación) -->
                <div v-if="documentosEtapa1.length > 0">
                  <v-subheader class="px-0">Documentos de Postulación (Etapa 1)</v-subheader>
                  <v-list dense>
                    <v-list-item
                      v-for="doc in documentosEtapa1"
                      :key="doc.tipo"
                    >
                      <v-list-item-icon>
                        <v-icon color="red">mdi-file-pdf-box</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ doc.nombre }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click="descargarArchivoPostulacion(doc.tipo)"
                        >
                          <v-icon small>mdi-download</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider class="mb-2" />
                </div>

                <!-- Documentos de Etapa 2 (Asignación) -->
                <div v-if="documentos.length === 0 && documentosEtapa1.length === 0" class="text-center py-5 grey--text">
                  <v-icon size="48" color="grey lighten-2">mdi-file-document-outline</v-icon>
                  <p class="mt-2">No hay documentos subidos</p>
                </div>
                <template v-if="documentos.length > 0">
                  <v-subheader v-if="documentosEtapa1.length > 0" class="px-0">Documentos de Asignación (Etapa 2)</v-subheader>
                  <v-list dense>
                    <template v-for="(grupo, transicion) in documentosAgrupados">
                      <v-subheader :key="'header-' + transicion" class="px-0">
                        {{ formatearTransicion(transicion) }}
                      </v-subheader>
                      <v-list-item
                        v-for="(doc, idx) in grupo"
                        :key="'doc-' + transicion + '-' + idx"
                      >
                        <v-list-item-icon>
                          <v-icon color="red">mdi-file-pdf-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ doc.nombre_original || doc.tipo }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ doc.tipo }} - {{ formatearFecha(doc.fecha) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if="esSubdere">
                          <v-btn
                            icon
                            small
                            color="error"
                            @click="eliminarDocumento(doc._index)"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider :key="'div-' + transicion" />
                    </template>
                  </v-list>
                </template>
              </v-card-text>
            </v-tab-item>

            <!-- Tab Observaciones -->
            <v-tab-item>
              <v-card-text>
                <!-- Agregar observación (solo SUBDERE) -->
                <div v-if="esSubdere" class="mb-4">
                  <v-textarea
                    v-model="nuevaObservacion"
                    label="Agregar observación"
                    outlined
                    dense
                    rows="3"
                    counter="2000"
                    :rules="[v => !v || v.length <= 2000 || 'Máximo 2000 caracteres']"
                  />
                  <v-btn
                    color="primary"
                    small
                    :loading="enviandoObservacion"
                    :disabled="!nuevaObservacion || nuevaObservacion.length > 2000"
                    @click="agregarObservacion"
                  >
                    <v-icon left small>mdi-send</v-icon>
                    Enviar observación
                  </v-btn>
                </div>

                <div v-if="observaciones.length === 0" class="text-center py-5 grey--text">
                  <v-icon size="48" color="grey lighten-2">mdi-comment-outline</v-icon>
                  <p class="mt-2">No hay observaciones</p>
                </div>

                <!-- Lista de observaciones -->
                <v-timeline v-else dense>
                  <v-timeline-item
                    v-for="obs in observaciones"
                    :key="obs.id"
                    :color="obs.respuesta ? 'green' : 'orange'"
                    small
                  >
                    <v-card outlined class="pa-3">
                      <div class="d-flex align-center mb-1">
                        <strong>{{ obs.usuario_nombre }}</strong>
                        <v-chip x-small class="ml-2" :color="obs.rol === 'subdere' ? 'blue' : 'green'" dark>
                          {{ obs.rol === 'subdere' ? 'SUBDERE' : 'Municipalidad' }}
                        </v-chip>
                        <v-spacer />
                        <span class="text-caption grey--text">{{ formatearFecha(obs.fecha) }}</span>
                      </div>
                      <p class="mb-0">{{ obs.texto }}</p>

                      <!-- Respuesta -->
                      <div v-if="obs.respuesta" class="mt-3 pl-3" style="border-left: 3px solid #4CAF50;">
                        <div class="text-caption grey--text">Respuesta - {{ formatearFecha(obs.respuesta_fecha) }}</div>
                        <p class="mb-0">{{ obs.respuesta }}</p>
                      </div>

                      <!-- Campo para responder (municipalidad) -->
                      <div v-else-if="!esSubdere" class="mt-3">
                        <v-textarea
                          v-model="respuestas[obs.id]"
                          label="Responder observación"
                          outlined
                          dense
                          rows="2"
                          hide-details
                        />
                        <v-btn
                          small
                          color="primary"
                          class="mt-2"
                          :loading="respondiendo === obs.id"
                          :disabled="!respuestas[obs.id]"
                          @click="responderObservacion(obs.id)"
                        >
                          Responder
                        </v-btn>
                      </div>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-tab-item>

            <!-- Tab Bitácora -->
            <v-tab-item>
              <v-card-text>
                <div v-if="bitacora.length === 0" class="text-center py-5 grey--text">
                  <v-icon size="48" color="grey lighten-2">mdi-history</v-icon>
                  <p class="mt-2">No hay registros en la bitácora</p>
                </div>
                <v-timeline v-else dense>
                  <v-timeline-item
                    v-for="(entry, idx) in bitacora"
                    :key="idx"
                    :color="getEstadoColor(entry.estado_nuevo)"
                    small
                  >
                    <v-card outlined class="pa-3">
                      <div class="d-flex align-center mb-1">
                        <v-chip x-small :color="getEstadoColor(entry.estado_anterior)" dark>
                          {{ getEstadoTexto(entry.estado_anterior) }}
                        </v-chip>
                        <v-icon small class="mx-2">mdi-arrow-right</v-icon>
                        <v-chip x-small :color="getEstadoColor(entry.estado_nuevo)" dark>
                          {{ getEstadoTexto(entry.estado_nuevo) }}
                        </v-chip>
                        <v-spacer />
                        <span class="text-caption grey--text">{{ formatearFecha(entry.fecha) }}</span>
                      </div>
                      <div class="text-caption">
                        Por: {{ entry.usuario_nombre }}
                      </div>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

      <!-- Columna derecha: Formulario de Asignación -->
      <v-col cols="12" md="6">
        <v-card v-if="postulacion.formulario_asignacion && !['enviada', 'observada', 'validada', 'lista_espera'].includes(postulacion.estado)">
          <v-card-title>
            <v-icon left class="mr-2">mdi-form-select</v-icon>
            Formulario de Asignación
            <v-spacer />
            <v-btn
              v-if="esSubdere && !edicionHabilitadaSubdere && ['beneficiario', 'dejacion', 'cese_funciones', 'fallecimiento'].includes(postulacion.estado)"
              small
              outlined
              color="warning"
              @click="edicionHabilitadaSubdere = true"
            >
              <v-icon small left>mdi-pencil</v-icon>
              Habilitar edición
            </v-btn>
            <v-chip v-if="!formularioEditable" small color="grey" dark>Solo lectura</v-chip>
          </v-card-title>
          <v-card-text>
            <!-- ═══ CAMPOS COMUNES (todos los estados) ═══ -->
            <v-subheader class="px-0 font-weight-bold">Oficio Alcaldicio</v-subheader>
            <v-text-field
              v-model="formulario.numero_oficio_alcaldicio"
              label="N° oficio alcaldicio"
              outlined
              dense
              :readonly="!formularioEditable"
            />
            <v-text-field
              v-model="formulario.fecha_oficio_alcaldicio"
              label="Fecha oficio alcaldicio"
              outlined
              dense
              type="date"
              :readonly="!formularioEditable"
            />

            <!-- ═══ CAMPOS DE DEJACIÓN (dejación y posteriores, no desiste) ═══ -->
            <template v-if="mostrarSeccionDejacion">
              <v-subheader class="px-0 font-weight-bold">Datos de Dejación</v-subheader>
              <v-text-field
                v-model="formulario.fecha_cese_funciones"
                label="Fecha cese de funciones"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
              <v-radio-group
                v-model="formulario.solicita_anticipo_fcm"
                label="¿Solicita Anticipo F.C.M?"
                row
                :readonly="!formularioEditable"
              >
                <v-radio :value="false" label="No" />
                <v-radio :value="true" label="Sí" />
              </v-radio-group>

              <template v-if="postulacion.sector !== 'cementerio'">
                <v-subheader class="px-0 font-weight-bold">Bonificaciones ($)</v-subheader>
                <v-text-field
                  v-model="bonificacionRetiroPesosFormateada"
                  label="Bonificación retiro voluntario ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model="bonificacionComplementariaPesosFormateada"
                  label="Bonificación complementaria ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model="bonificacionMunicipalPesosFormateada"
                  label="Bonificación cargo municipal ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  :readonly="!formularioEditable"
                />
              </template>

              <!-- Campos de Convenio Anticipo FCM -->
              <v-subheader class="px-0 font-weight-bold">Convenio</v-subheader>
              <v-text-field
                v-model="formulario.numero_expediente"
                label="Número expediente"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.numero_convenio"
                label="Número convenio"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.numero_decreto_ministerial"
                label="Número decreto ministerial"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_decreto_ministerial"
                label="Fecha decreto ministerial"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_transferencia_tesoreria_fcm"
                label="Fecha de Transf. Tesorería FCM"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
            </template>

            <!-- ═══ DOCUMENTOS ANTICIPO FCM (solo dejación con solicita_anticipo_fcm) ═══ -->
            <template v-if="mostrarSeccionDejacion && formulario.solicita_anticipo_fcm">
              <v-subheader class="px-0 font-weight-bold">Documentos Solicitud Anticipo FCM</v-subheader>
              <v-card
                v-for="(doc, idx) in documentosAnticipoFcm"
                :key="'afcm-' + idx"
                outlined
                class="pa-3 mb-2"
              >
                <div class="d-flex align-center mb-2">
                  <v-icon
                    :color="doc.subido ? 'green' : 'red'"
                    class="mr-2"
                  >
                    {{ doc.subido ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                  </v-icon>
                  <span class="text-body-2">{{ doc.label }}</span>
                </div>
                <v-file-input
                  v-if="!doc.subido && formularioEditable"
                  v-model="archivosAnticipoFcm[doc.tipo]"
                  accept=".pdf"
                  :label="'Seleccionar ' + doc.label"
                  outlined
                  dense
                  hide-details
                  prepend-icon="mdi-file-pdf-box"
                  @change="subirDocumentoAnticipoFcm(doc.tipo)"
                />
                <v-chip v-if="doc.subido" small color="green" dark>
                  <v-icon small left>mdi-check</v-icon>
                  Documento subido
                </v-chip>
              </v-card>
            </template>

            <!-- ═══ CAMPOS DE CESE DE FUNCIONES (cese y posteriores) ═══ -->
            <template v-if="mostrarSeccionCese">
              <v-subheader class="px-0 font-weight-bold">Datos del Cese de Funciones</v-subheader>
              <v-select
                v-model="formulario.causa_cese"
                :items="opcionesCausaCese"
                label="Causa de cese"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-if="!mostrarSeccionDejacion"
                v-model="formulario.fecha_cese_funciones"
                label="Fecha cese de funciones"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model.number="formulario.jornada_trabajo"
                label="Horas de jornada de trabajo"
                outlined
                dense
                type="number"
                :readonly="!formularioEditable"
              />

              <v-subheader class="px-0 font-weight-bold">Antigüedad</v-subheader>
              <v-text-field
                v-model.number="formulario.anios_antiguedad_postular"
                label="Años antigüedad postular"
                outlined
                dense
                type="number"
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model.number="formulario.anios_antiguedad_cese"
                label="Años de antigüedad al cese de funciones"
                outlined
                dense
                type="number"
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model.number="formulario.antiguedad_otros_municipios"
                label="Antigüedad laboral otros municipios"
                outlined
                dense
                type="number"
                :readonly="!formularioEditable"
              />
              <v-text-field
                :value="totalAntiguedadCalculado"
                label="Total antigüedad"
                outlined
                dense
                readonly
                filled
              />

              <v-subheader class="px-0 font-weight-bold">Bonificaciones (UF)</v-subheader>
              <v-text-field
                v-model.number="formulario.bonificacion_adicional_uf"
                label="Bonificación adicional (UF)"
                outlined
                dense
                type="number"
                suffix="UF"
                :readonly="!formularioEditable"
              />
              <template v-if="postulacion.sector !== 'cementerio'">
                <v-text-field
                  v-model.number="formulario.bono_antiguedad_uf"
                  label="Bono antigüedad (UF)"
                  outlined
                  dense
                  type="number"
                  suffix="UF"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model.number="formulario.anios_trabajo_pesado"
                  label="Años trabajo pesado"
                  outlined
                  dense
                  type="number"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model.number="formulario.bono_trabajo_pesado_uf"
                  label="Bono trabajo pesado (UF)"
                  outlined
                  dense
                  type="number"
                  suffix="UF"
                  :readonly="!formularioEditable"
                />
                <v-file-input
                  v-if="formularioEditable"
                  v-model="archivoTrabajoPesadoAfp"
                  accept=".pdf"
                  label="Certificado Trabajo Pesado AFP"
                  outlined
                  dense
                  prepend-icon="mdi-file-pdf-box"
                  hint="Seleccione el certificado y se subirá al guardar"
                  persistent-hint
                />
                <v-chip v-if="formulario.archivo_trabajo_pesado_afp_url" small color="green" dark class="mb-4">
                  <v-icon small left>mdi-check</v-icon>
                  Certificado Trabajo Pesado AFP subido
                </v-chip>
              </template>

              <v-subheader class="px-0 font-weight-bold">Decreto de Cese</v-subheader>
              <v-text-field
                v-model="formulario.numero_decreto_cese"
                label="N° decreto cese de funciones"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_decreto_cese"
                label="Fecha decreto cese de funciones"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
            </template>

            <!-- ═══ CAMPOS SOLO DESISTIMIENTO ═══ -->
            <template v-if="mostrarSeccionDesiste">
              <v-text-field
                v-model="formulario.numero_expediente"
                label="Número expediente"
                outlined
                dense
                :readonly="!formularioEditable"
              />
            </template>

            <!-- ═══ OBSERVACIÓN (todos los estados) ═══ -->
            <v-subheader class="px-0 font-weight-bold">Observación</v-subheader>
            <v-textarea
              v-model="formulario.observacion"
              label="Observación del formulario"
              outlined
              dense
              rows="3"
              :readonly="!formularioEditable"
            />

            <!-- Botón guardar -->
            <v-btn
              v-if="formularioEditable"
              color="primary"
              :loading="guardandoFormulario"
              @click="guardarFormularioAsignacion"
            >
              <v-icon left>mdi-content-save</v-icon>
              Guardar Formulario
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo confirmar transición -->
    <v-dialog v-model="dialogConfirmar" max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          Confirmar cambio de estado
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea cambiar el estado de
          <strong>{{ getEstadoTexto(postulacion.estado) }}</strong>
          a
          <strong>{{ getEstadoTexto(transicionSeleccionada) }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirmar = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text :loading="procesandoTransicion" @click="ejecutarTransicion">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { apiClient } from '@/admin/services/API'
import { format } from 'date-fns'
import { notificar, notificarErrorResponse } from '@/admin/utils/notificar'

export default {
  name: 'AsignacionBeneficiarioDetalle',
  data() {
    return {
      postulacion: {},
      transicionesDisponibles: [],
      transicionSeleccionada: null,
      documentosRequeridos: [],
      archivosTransicion: {},
      documentos: [],
      observaciones: [],
      bitacora: [],
      cargando: false,
      procesandoTransicion: false,
      enviandoObservacion: false,
      respondiendo: null,
      tabActiva: 0,
      dialogConfirmar: false,
      nuevaObservacion: '',
      respuestas: {},
      cumpleRequisitos: null,
      guardandoCumple: false,
      formulario: {},
      guardandoFormulario: false,
      documentosAnticipoFcm: [],
      archivosAnticipoFcm: {},
      archivoTrabajoPesadoAfp: null,
      edicionHabilitadaSubdere: false,
    }
  },
  computed: {
    bonificacionRetiroPesosFormateada: {
      get() {
        if (this.formulario.bonificacion_retiro_pesos == null || this.formulario.bonificacion_retiro_pesos === '') return ''
        return this.formulario.bonificacion_retiro_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_retiro_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionComplementariaPesosFormateada: {
      get() {
        if (this.formulario.bonificacion_complementaria_pesos == null || this.formulario.bonificacion_complementaria_pesos === '') return ''
        return this.formulario.bonificacion_complementaria_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_complementaria_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionMunicipalPesosFormateada: {
      get() {
        if (this.formulario.bonificacion_cargo_municipal_pesos == null || this.formulario.bonificacion_cargo_municipal_pesos === '') return ''
        return this.formulario.bonificacion_cargo_municipal_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_cargo_municipal_pesos = isNaN(num) ? null : num
      }
    },
    formularioEditable() {
      const estadosEditables = ['beneficiario', 'dejacion', 'cese_funciones', 'fallecimiento']
      if (!estadosEditables.includes(this.postulacion.estado)) return false
      if (this.esSubdere) return this.edicionHabilitadaSubdere
      return true
    },
    mostrarSeccionDesiste() {
      return ['desiste', 'desiste_confirmado'].includes(this.postulacion.estado)
    },
    mostrarSeccionDejacion() {
      return ['dejacion', 'cese_funciones', 'cese_confirmado', 'fallecimiento', 'fallecimiento_confirmado', 'pagado'].includes(this.postulacion.estado)
    },
    mostrarSeccionCese() {
      return ['cese_funciones', 'cese_confirmado', 'fallecimiento', 'fallecimiento_confirmado', 'pagado'].includes(this.postulacion.estado)
    },
    opcionesCausaCese() {
      return [
        { text: 'Renuncia Voluntaria', value: 'renuncia_voluntaria' },
        { text: 'Pensión de Invalidez', value: 'pension_invalidez' },
        { text: 'Artículo 161', value: 'articulo_161' },
      ]
    },
    totalAntiguedadCalculado() {
      const cese = Number(this.formulario.anios_antiguedad_cese) || 0
      const otros = Number(this.formulario.antiguedad_otros_municipios) || 0
      return cese + otros
    },
    esSubdere() {
      return this.$auth.can(['gestor-subdere-incentivo-retiro'])
    },
    transicionesDisponiblesSelect() {
      return this.transicionesDisponibles.map((t) => ({
        text: this.getEstadoTexto(t),
        value: t,
      }))
    },
    documentosEtapa1() {
      const docs = []
      if (this.postulacion.archivo_prepostulacion_url) {
        docs.push({ tipo: 'prepostulacion', nombre: 'Formulario de Prepostulación' })
      }
      if (this.postulacion.archivo_postulacion_firmada_url) {
        docs.push({ tipo: 'documento_firmado', nombre: 'Postulación Firmada' })
      }
      if (this.postulacion.archivo_trabajo_pesado_url) {
        docs.push({ tipo: 'trabajo-pesado', nombre: 'Certificado Trabajo Pesado' })
      }
      if (this.postulacion.archivo_invalidez_url) {
        docs.push({ tipo: 'invalidez', nombre: 'Certificado de Invalidez' })
      }
      if (this.postulacion.certificado.certificado_cumplimiento_firmado_url) {
        docs.push({ tipo: 'certificado_cumplimiento', nombre: 'Certificado de Cumplimiento Firmado' })
      }
      if (this.postulacion.certificado.decreto_alcaldicio_url) {
        docs.push({ tipo: 'decreto', nombre: 'Decreto Alcaldicio' })
      }
      const historial = this.postulacion.historial_laboral || []
      historial.forEach((item, index) => {
        if (item.certificado_archivo_url) {
          docs.push({
            tipo: `certificado_antiguedad_${index}`,
            nombre: `Certificado de Antigüedad — ${item.institucion || `Registro ${index + 1}`}`,
          })
        }
      })
      return docs
    },
    documentosAgrupados() {
      const grupos = {}
      this.documentos.forEach((doc, index) => {
        const key = doc.transicion || 'sin_transicion'
        if (!grupos[key]) grupos[key] = []
        grupos[key].push({ ...doc, _index: index })
      })
      return grupos
    },
    observacionesSinResponder() {
      return this.observaciones.filter((o) => !o.respuesta).length
    },
    puedeConfirmarTransicion() {
      if (!this.transicionSeleccionada) return false
      // Verificar que todos los documentos obligatorios estén subidos o se hayan seleccionado archivos
      const obligatoriosFaltantes = this.documentosRequeridos.filter(
        (doc) => doc.obligatorio && !doc.subido && !this.archivosTransicion[doc.tipo]
      )
      return obligatoriosFaltantes.length === 0
    },
  },
  mounted() {
    this.cargarDetalle()
  },
  methods: {
    async cargarDetalle() {
      this.cargando = true
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}`
        )
        this.postulacion = data.postulacion
        this.transicionesDisponibles = data.transiciones_disponibles || []
        this.documentos = data.postulacion.documentos || []
        this.observaciones = data.postulacion.observaciones || []
        this.bitacora = data.postulacion.bitacora || []
        this.cumpleRequisitos = data.postulacion.cumple_requisitos
        this.formulario = { ...(data.postulacion.formulario_asignacion || {}) }
        // Cargar documentos anticipo FCM si aplica
        if (this.formulario.solicita_anticipo_fcm) {
          this.cargarDocumentosAnticipoFcm()
        }
      } catch (error) {
        notificarErrorResponse(error, 'Error al cargar detalle del beneficiario')
        console.error(error)
      } finally {
        this.cargando = false
      }
    },
    async guardarCumpleRequisitos() {
      if (this.cumpleRequisitos === null) {
        notificar({ message: 'Debe seleccionar una opción', severity: 'error' })
        return
      }
      this.guardandoCumple = true
      try {
        await apiClient.put(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/cumple-requisitos`,
          { cumple_requisitos: this.cumpleRequisitos }
        )
        notificar({ message: 'Evaluación guardada correctamente', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al guardar evaluación')
      } finally {
        this.guardandoCumple = false
      }
    },
    async guardarFormularioAsignacion() {
      this.guardandoFormulario = true
      try {
        // Subir Certificado Trabajo Pesado AFP si hay archivo seleccionado
        if (this.archivoTrabajoPesadoAfp) {
          const formData = new FormData()
          formData.append('tipo', 'certificado_trabajo_pesado_afp')
          formData.append('transicion', 'formulario_asignacion')
          formData.append('archivo', this.archivoTrabajoPesadoAfp)
          const { data: docData } = await apiClient.post(
            `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          this.formulario.archivo_trabajo_pesado_afp_url = docData.documento?.path || true
          this.archivoTrabajoPesadoAfp = null
        }
        // Actualizar total_antiguedad calculado
        this.formulario.total_antiguedad = this.totalAntiguedadCalculado
        await apiClient.put(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/formulario-asignacion`,
          this.formulario
        )
        notificar({ message: 'Formulario guardado correctamente', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al guardar formulario')
      } finally {
        this.guardandoFormulario = false
      }
    },
    async cargarDocumentosAnticipoFcm() {
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos-anticipo-fcm`
        )
        this.documentosAnticipoFcm = data.documentos_anticipo_fcm || []
      } catch (error) {
        console.error('Error al cargar documentos anticipo FCM', error)
      }
    },
    async subirDocumentoAnticipoFcm(tipo) {
      const archivo = this.archivosAnticipoFcm[tipo]
      if (!archivo) return
      try {
        const formData = new FormData()
        formData.append('tipo', tipo)
        formData.append('transicion', 'anticipo_fcm')
        formData.append('archivo', archivo)
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        notificar({ message: 'Documento subido exitosamente', severity: 'success' })
        this.$set(this.archivosAnticipoFcm, tipo, null)
        await this.cargarDocumentosAnticipoFcm()
      } catch (error) {
        notificarErrorResponse(error, 'Error al subir documento')
      }
    },
    async cargarDocumentosRequeridos() {
      if (!this.transicionSeleccionada) {
        this.documentosRequeridos = []
        return
      }
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos-requeridos`,
          { params: { estado_nuevo: this.transicionSeleccionada } }
        )
        this.documentosRequeridos = data.documentos_requeridos || []
        this.archivosTransicion = {}
      } catch (error) {
        notificarErrorResponse(error, 'Error al cargar documentos requeridos')
      }
    },
    confirmarTransicion() {
      this.dialogConfirmar = true
    },
    async ejecutarTransicion() {
      this.procesandoTransicion = true
      try {
        // Primero subir los archivos pendientes
        const clave = `${this.postulacion.estado}_${this.transicionSeleccionada}`
        for (const [tipo, archivo] of Object.entries(this.archivosTransicion)) {
          if (archivo) {
            const formData = new FormData()
            formData.append('tipo', tipo)
            formData.append('transicion', clave)
            formData.append('archivo', archivo)
            await apiClient.post(
              `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            )
          }
        }

        // Luego ejecutar la transición
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/transicion`,
          { estado_nuevo: this.transicionSeleccionada }
        )

        notificar({ message: 'Estado actualizado exitosamente', severity: 'success' })
        this.dialogConfirmar = false
        this.transicionSeleccionada = null
        this.documentosRequeridos = []
        this.archivosTransicion = {}
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al cambiar estado')
        console.error(error)
      } finally {
        this.procesandoTransicion = false
      }
    },
    async eliminarDocumento(index) {
      if (!confirm('¿Está seguro que desea eliminar este documento?')) return
      try {
        await apiClient.delete(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos/${index}`
        )
        notificar({ message: 'Documento eliminado', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al eliminar documento')
      }
    },
    async agregarObservacion() {
      this.enviandoObservacion = true
      try {
        const { data } = await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/observaciones`,
          { texto: this.nuevaObservacion }
        )
        this.observaciones = data.observaciones || []
        this.nuevaObservacion = ''
        notificar({ message: 'Observación agregada', severity: 'success' })
      } catch (error) {
        notificarErrorResponse(error, 'Error al agregar observación')
      } finally {
        this.enviandoObservacion = false
      }
    },
    async responderObservacion(obsId) {
      this.respondiendo = obsId
      try {
        const { data } = await apiClient.put(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/observaciones/${obsId}/respuesta`,
          { respuesta: this.respuestas[obsId] }
        )
        this.observaciones = data.observaciones || []
        this.$delete(this.respuestas, obsId)
        notificar({ message: 'Respuesta registrada', severity: 'success' })
      } catch (error) {
        notificarErrorResponse(error, 'Error al responder observación')
      } finally {
        this.respondiendo = null
      }
    },
    getNombreCompleto(item) {
      return [item.nombres, item.apellido_paterno, item.apellido_materno].filter(Boolean).join(' ')
    },
    getEstadoColor(estado) {
      const colores = {
        enviada: 'deep-purple',
        observada: 'amber darken-2',
        validada: 'light-blue',
        lista_espera: 'orange',
        beneficiario: 'blue',
        dejacion: 'purple',
        desiste: 'red lighten-1',
        desiste_confirmado: 'red darken-2',
        cese_funciones: 'teal',
        cese_confirmado: 'teal darken-2',
        fallecimiento: 'brown',
        fallecimiento_confirmado: 'brown darken-2',
        pagado: 'green',
      }
      return colores[estado] || 'grey'
    },
    getEstadoTexto(estado) {
      const textos = {
        enviada: 'Enviada',
        observada: 'Observada',
        validada: 'Validada',
        lista_espera: 'Lista de Espera',
        beneficiario: 'Beneficiario',
        dejacion: 'Dejación',
        desiste: 'Desiste',
        desiste_confirmado: 'Desiste Confirmado',
        cese_funciones: 'Cese de Funciones',
        cese_confirmado: 'Cese Confirmado',
        fallecimiento: 'Fallecimiento',
        fallecimiento_confirmado: 'Fallecimiento Confirmado',
        pagado: 'Pagado',
      }
      return textos[estado] || estado
    },
    getSectorColor(sector) {
      return sector === 'cementerio' ? 'deep-purple lighten-4' : 'blue lighten-4'
    },
    getSectorTexto(sector) {
      const textos = {
        municipal: 'Municipal',
        cementerio: 'Cementerio',
      }
      return textos[sector] || sector || '-'
    },
    formatearTransicion(transicion) {
      // Las claves de transición tienen formato "estadoOrigen_estadoDestino"
      // Intentar parsear conociendo los estados válidos
      const estadosConocidos = [
        'enviada', 'observada', 'validada', 'lista_espera', 'beneficiario', 'dejacion', 'desiste',
        'desiste_confirmado', 'cese_funciones', 'cese_confirmado',
        'fallecimiento', 'fallecimiento_confirmado', 'pagado',
      ]
      for (const estado of estadosConocidos) {
        if (transicion.startsWith(estado + '_')) {
          const resto = transicion.slice(estado.length + 1)
          if (estadosConocidos.includes(resto)) {
            return `${this.getEstadoTexto(estado)} → ${this.getEstadoTexto(resto)}`
          }
        }
      }
      return transicion
    },
    formatearFecha(fecha) {
      if (!fecha) return '-'
      try {
        return format(new Date(fecha), 'DD/MM/YYYY HH:mm')
      } catch {
        return fecha
      }
    },
    descargarArchivoPostulacion(tipoArchivo) {
      let url = `/tramites/incentivos-retiro/postulaciones/${this.postulacion.id}/archivo/${tipoArchivo}`
      if (['decreto', 'certificado_cumplimiento'].includes(tipoArchivo)) {
        url = `/tramites/incentivos-retiro/certificados/${this.postulacion.certificado_id}/archivo/${tipoArchivo}`
      }

      apiClient
        .get(url, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = tipoArchivo + '.pdf'
          link.click()
          notificar({ message: 'Descarga exitosa', severity: 'success' })
        })
        .catch(() => {
          notificar({ message: 'El archivo no se encuentra disponible', severity: 'error' })
        })
    },
  },
}
</script>
